<template>
    <div>
        <p v-if="value.length === 0"
           class="mensagem-quando-vazio">
            Não houveram vencedores para este item.
        </p>

        <v-data-table v-else :headers="colunasTabela" :items="value" hide-actions
                      class="az-table-list tabela-ranking"
                      no-data-text="Não houveram vencedores para este item.">
            <template slot="headers" slot-scope="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text"
                        :style="'text-align: '+ header.align + ';' + 'width: ' + header.width + ';'"
                        :class="header.class">
                        <div v-if="header.text === ''">
                            <i size="20" class="fas fa-trophy" aria-hidden="true"/>
                        </div>
                        <span>{{ header.text }}</span>
                    </th>
                </tr>
            </template>

            <template slot="items" slot-scope="props">
                <tr id="linha-tabela-ranking" v-bind:class="estilizarLinhaCondicionalmente(props.item.status)">
                    <td align="center">
                        <div class="circulo">
                            <span v-if="props.item.posicao">{{ props.item.posicao }}°</span>
                            <span v-else>?&nbsp;</span>
                        </div>
                    </td>
                    <td align="left">
                        {{ props.item.razaoSocial }}<br/>
                        <contato-fornecedor :titulo="'Contato de ' + props.item.razaoSocial" :contato="props.item.contato"/>
                    </td>
                    <td align="right">
                        <span>{{ props.item.lanceVencedor | cdCurrency(prefix, casasDecimais)}}{{suffix}}</span>
                    </td>
                    <!--REAJUSTE/NEGOCIACAO-->
                    <td align="center">
                      <v-tooltip top>
                              <span v-if="props.item.situacaoReajuste === 'FINALIZADO'" slot="activator">
                                  {{ props.item.lanceVencedorReajustado | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                              </span>

                              <span v-else slot="activator">
                                  Aguardando<br>Envio
                              </span>
                        <span>Este campo refere-se ao valor inicial da proposta do fornecedor caso ainda não tenha sido preenchido o valor do reajuste ou negociação.</span>
                      </v-tooltip>
                    </td>

                    <td align="center">
                      <v-tooltip top v-if="['DESCLASSIFICADO', 'INABILITADO'].includes(props.item.status)">
                              <span slot="activator">
                                {{ props.item.status | azEnum(situacoesFornecedores) }}
                                <v-icon size="10px" style="vertical-align: middle">fas fa-comment</v-icon>
                              </span>
                              {{ props.item.motivoDesclassificacao }}
                      </v-tooltip>
                      <span v-else>
                            {{ props.item.status | azEnum(situacoesFornecedores) }}
                        </span>
                        <span v-if="props.item.negociacao">
                            <span v-if="props.item.negociacao.aceito === true">
                                <v-tooltip top>
                                    <span slot="activator">
                                        <v-icon size="14px" class="ml-1" color="primary">far fa-check-circle</v-icon>
                                    </span>
                                    <span>A última negociação enviada foi aceita, o valor enviado foi de
                                      {{ props.item.negociacao.valor | cdCurrency(prefix, casasDecimais)}}{{suffix}}</span>
                                </v-tooltip>
                            </span>
                            <span v-else-if="props.item.negociacao.aceito === false">
                                <v-tooltip top>
                                    <span slot="activator">
                                        <v-icon size="14px" class="ml-1" color="error">far fa-times-circle</v-icon>
                                    </span>
                                    <span>Negociação Recusada.</span>
                                </v-tooltip>
                            </span>
                            <span v-else>
                                <v-tooltip top>
                                    <span slot="activator">
                                        <v-icon size="17px" class="ml-1">far fa-handshake</v-icon>
                                    </span>
                                    <span v-if="props.item.status === 'EM_ANALISE'">Aguardando o fornecedor aceitar
                                        a última negociação</span>
                                    <span v-else>Não houve resposta para a última negociação</span>
                                </v-tooltip>
                            </span>
                        </span>
                    </td>
                    <td align="center">
                        <documentacao v-model="props.item.documentacao"
                                      :statusFornecedor="props.item.status"
                                      :is-doc-apresentado="props.item.temDocFornecedor"
                                      :situacaoItemOuLote="situacaoItemOuLote"
                                      :permitirVisualizarDocumentoDesempate="permitirVisualizarDocumentoDesempate(props.item)"
                                      @baixarTodosDocumentos="baixarTodosDocumentos(props.item.pessoaId, props.item.razaoSocial)"
                                      @analisar="analisarDoc(props.item.pessoaId, props.item.itemCompraDiretaId,
                                                            props.item.loteCompraDiretaId)"/>
                    </td>
                    <td align="center" v-if="itemLoteEstaEmHomologacao">
                       <div v-if="ehProcessamentoLegal(props.item)">
                           <span> {{ situacoesHomologacao[props.item.processamento] }} </span>
                           <v-btn v-if="props.item.processamento === 'DEVOLVIDO'" icon small flat color="warning"
                                  @click.stop="$emit('eventoMostrarMotivoDevolucao', props.item)">
                               <v-icon>info</v-icon>
                           </v-btn>
                       </div>
                        <span v-else> -- </span>
                    </td>
                    <td align="center" v-if="deveExibirAcoes(situacaoItemOuLote, props.item)">
                        <div class="actions" v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'" style="justify-content: center">
                          <botao-declarar-vencedor v-if="mostrarBotaoAdjudicar(props.item) && !ehCompraSuspensa()"
                                             :itemOuLoteDescricao="itemOuLoteDescricao"
                                             :razaoSocial="props.item.razaoSocial"
                                             :mensagemValorAcimaDaReferencia="adjudicarRequerConfirmacao"
                                             :criterioJulgamento="criterioJulgamento"
                                             @declararVencedor="$emit('declararVencedor', props.item.rankingId, props.item.pessoaId, itemOuLoteId, situacaoItemOuLote)" />
                            <botao-enviar-para-homologacao v-else-if="mostrarBotaoEnviarParaHomologacao(props.item) && !ehCompraSuspensa()"
                                                           v-az-auth="'Comprador.Admin,Comprador.Normal'"
                                                           @enviarParaHomologacao="$emit('enviarParaHomologacao', props.item.rankingId)"/>

                            <v-menu offset-y left v-if="mostrarBotaoMaisOpcoes(props.item)">
                                <v-btn class="botaoMaisAcoes" slot="activator" icon>
                                    <v-icon color="#7d7d7d">more_vert</v-icon>
                                </v-btn>
                                <v-list v-if="mostrarCancelarEnvioHomologacao(props.item) && !ehCompraSuspensa()">
                                    <acoes-devolver-item-lote v-az-auth="'Comprador.Autoridade.Superior'"
                                                              @devolver="$emit('abrirModalParaDevolucao', props.item)"/>
                                    <acoes-cancelar-envio-homologacao v-az-auth="'Comprador.Admin,Comprador.Normal'"
                                                                      @eventoCancelarEnvioHomologacao="propagarEventoCancelarEnvioHomologacao(props.item.rankingId)"/>
                                </v-list>
                                <v-list v-else class="lista-menu">
                                    <acoes-reclassificar  v-if="mostrarOpcaoReclassificar(props.item) && !ehCompraSuspensa()"
                                                          :key="`${itemOuLoteDescricao}:${props.item.pessoaId}:${props.item.posicao}`"
                                                          :itemOuLoteDescricao="itemOuLoteDescricao"
                                                          :razaoSocial="props.item.razaoSocial"
                                                          :itemOuLoteId="itemOuLoteId"
                                                          @reclassificar="propagarEventoReclassificar(props.item.rankingId, ...arguments)"/>
                                    <acoes-desclassificar v-if="mostrarOpcoesNegociarEDesclassificar(props.item) && !ehCompraSuspensa()"
                                                          :itemOuLoteDescricao="itemOuLoteDescricao"
                                                          :razaoSocial="props.item.razaoSocial"
                                                          @desclassificar="propagarEventoDesclassificar(props.item.rankingId, ...arguments)"/>
                                    <acoes-habilitar v-if="mostrarOpcoesHabilitar(props.item) && !ehCompraSuspensa()"
                                                     :itemOuLoteDescricao="itemOuLoteDescricao"
                                                     :razaoSocial="props.item.razaoSocial"
                                                     @habilitar="propagarEventoHabilitar(props.item.pessoaId, props.item.rankingId, ...arguments)"/>
                                    <acoes-inabilitar v-if="mostrarOpcoesNegociarEDesclassificar(props.item) && !ehCompraSuspensa()"
                                                      :itemOuLoteDescricao="itemOuLoteDescricao"
                                                      :razaoSocial="props.item.razaoSocial"
                                                      @inabilitar="propagarEventoInabilitar(props.item.pessoaId, props.item.rankingId, ...arguments)"/>
                                    <span v-if="props.item.negociacao !== null && props.item.status !== 'ADJUDICADO' && !ehCompraSuspensa()">
                                        <acoes-negociar v-if="props.item.negociacao.aceito !== null  && !ehCompraSuspensa() && !ehCompraPropostaManualEhAtiva()"
                                                        :itemOuLoteDescricao="itemOuLoteDescricao"
                                                        :razaoSocial="props.item.razaoSocial"
                                                        :lanceVencedor="props.item.lanceVencedor"
                                                        :casasDecimais="casasDecimais"
                                                        :prefix="prefix"
                                                        :suffix="suffix"
                                                        @negociar="propagarEventoNegociar(props.item.rankingId, ...arguments)"/>
                                      <acoes-cancelar-negociacao v-if="props.item.negociacao && !ehCompraSuspensa() && !ehCompraPropostaManualEhAtiva()"
                                                                 :razao-social="props.item.razaoSocial"
                                                                 :item-ou-lote-descricao="itemOuLoteDescricao"
                                                                 @cancelarNegociacao="propagarEventoCancelarNegociacao(props.item, $event.motivo)"/>
                                    </span>

                                    <acoes-negociar v-else-if="mostrarOpcoesNegociarEDesclassificar(props.item) && !ehCompraSuspensa() && !ehCompraPropostaManualEhAtiva()"
                                            :itemOuLoteDescricao="itemOuLoteDescricao"
                                            :razaoSocial="props.item.razaoSocial"
                                            :lanceVencedor="props.item.lanceVencedor"
                                            :prefixSuffixValor="prefixOuSuffixValor"
                                            :casasDecimais="casasDecimais"
                                            :prefix="prefix"
                                            :suffix="suffix"
                                            @negociar="propagarEventoNegociar(props.item.rankingId, ...arguments)"/>

                                    <acoes-abrir-mensagens v-if="mostarBotaoMensagens && !ehCompraPropostaManualEhAtiva()"
                                                           @abrirChatMensages="$emit('abrirChatMensages', props.item)"/>

                                    <acoes-cancelar-adjudicacao v-if="mostrarOpcaoCancelarAdjudicacao(props.item) && !ehCompraSuspensa()"
                                            :itemOuLoteDescricao="itemOuLoteDescricao"
                                            :razaoSocial="props.item.razaoSocial"
                                            @cancelarAdjudicacao="(motivo) =>propagarEventoCancelarAdjudicacao(props.item.rankingId, props.item.pessoaId, motivo)"/>

                                    <acoes-cancelar-declaracao-vencedor v-if="!ehFluxoAutoridadeSuperior && props.item.status === 'ADJUDICADO'
                                    && !ehCompraSuspensa()"
                                            :itemOuLoteDescricao="itemOuLoteDescricao"
                                            :razaoSocial="props.item.razaoSocial"
                                            @cancelarDeclaracaoVencedor="(motivo) => propagarEventoCancelarDeclaracaoVencedor(props.item.rankingId, props.item.pessoaId, motivo)"/>

                                  <acoes-solicitar-readequacao v-if="props.item.status !== 'ADJUDICADO'
                                                               && (props.item.status !== 'DESCLASSIFICADO' || props.item.status !== 'INABILITADO')
                                                               && !ehCompraSuspensa() && !ehCompraPropostaManualEhAtiva()"
                                                               @eventoAbrirModalSolicitarReadequacao="eventoAbrirModalSolicitarReadequacao(props.item)"/>
                                </v-list>
                            </v-menu>
                        </div>
                    </td>
                    <td align="center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              v-if="mostrarBotaoRemoverProposta()"
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="removerProposta(props.item)"
                          >
                            <v-icon color="grey lighten-1" size="15px">far fa-trash-alt</v-icon>
                          </v-btn>
                        </template>

                        <span>Excluir Proposta</span>
                      </v-tooltip>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesFornecedores, situacoesHomologacao} from '@/core/constants'
import ContatoFornecedor from './ContatoFornecedor'
import Documentacao from './Documentacao'
import AcoesDesclassificar from './acoes/AcoesDesclassificar'
import AcoesNegociar from './acoes/AcoesNegociar'
import AcoesReclassificar from './acoes/AcoesReclassificar'
import AcoesCancelarAdjudicacao from './acoes/AcoesCancelarAdjudicacao'
import AcoesSolicitarReadequacao from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesSolicitarReadequacao'
import AcoesCancelarNegociacao from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesCancelarNegociacao'
import AcoesAbrirMensagens from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesAbrirMensagens.vue'
import BotaoDeclararVencedor from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/BotaoDeclararVencedor'
import AcoesCancelarDeclaracaoVencedor from './acoes/AcoesCancelarDeclaracaoVencedor'
import BotaoEnviarParaHomologacao from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/BotaoEnviarParaHomologacao.vue'
import AcoesCancelarEnvioHomologacao from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesCancelarEnvioHomologacao.vue'
import AcoesDevolverItemLote from './acoes/AcoesDevolverItemLote'
import AcoesInabilitar from './acoes/AcoesInabilitar'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import AcoesHabilitar from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesHabilitar.vue'
export default {
    name: 'PainelRankingTabela',
    components: {
        AcoesHabilitar,
        AcoesDevolverItemLote,
        AcoesCancelarEnvioHomologacao,
        AcoesCancelarDeclaracaoVencedor,
        BotaoDeclararVencedor,
        AcoesCancelarNegociacao,
        AcoesCancelarAdjudicacao, ContatoFornecedor,
        Documentacao,
        AcoesInabilitar,
        AcoesDesclassificar, AcoesNegociar,
        AcoesReclassificar, AcoesSolicitarReadequacao,
        AcoesAbrirMensagens, BotaoEnviarParaHomologacao
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        situacaoItemOuLote: {
            required: true,
            type: String,
            default: 'EM_ANDAMENTO'
        },
        itemOuLoteDescricao: {
            required: true,
            type: String,
        },
        itemOuLoteId: {
            required: true,
            type: Number,
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        adjudicarRequerConfirmacao:{
            type: Boolean
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        compraDiretaId: {
            type: Number
        },
        estaEmHomologacao: {
            type: Boolean,
            default: false
        },
        lanceFechadoFinalizado: {
            type: Boolean,
            required: false,
            default: null
        },
        situacaoCompraDireta: {
            type: String,
            required: true,
        },
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            situacoesFornecedores,
            visibilidadeDialogoContatoFornecedor: false,
            tamanho: null,
            colunas: [
                {
                    text: '',
                    value: 'posicao',
                    align: 'center',
                    width: '5%',
                    class: 'primary--text',
                    sortable: false,
                },
                {
                    text: 'Fornecedor',
                    align: 'left',
                    value: 'fornecedor',
                    class: 'primary--text',
                    width: '20%',
                    sortable: false
                },
                {
                    text: 'Lance Venc.',
                    align: 'right',
                    value: 'lanceVencedor',
                    class: 'primary--text',
                    width: '15%',
                    sortable: false
                },
                {
                    text: 'Negociação',
                    align: 'center',
                    value: 'negociacao',
                    class: 'primary--text',
                    width: '15%',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'center',
                    width: '10%',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    value: 'documentacao',
                    text: 'Documentação',
                    width: '15%',
                    align: 'center',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    value: 'situacaoHomologacao',
                    text: 'Situação',
                    width: '15%',
                    align: 'center',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    value: 'acoes',
                    text: 'Ações',
                    width: '20%',
                    align: 'center',
                    class: 'primary--text',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        situacoesHomologacao() {
            return situacoesHomologacao
        },
        ...mapState(['loki', 'resumoCompraDireta', 'parametros']),
        colunasTabela() {
            return this.colunas.filter(coluna => {
                return !(coluna.text === 'Ações' && (!['EM_ANDAMENTO', 'ADJUDICADO'].includes(this.situacaoItemOuLote)))
                        || this.value.some(item => item.status === 'DESCLASSIFICADO')
            }).filter(coluna => this.predicate(coluna))
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        },
        prefixOuSuffixValor(){
            return this.prefixSuffixValor
        },
        ehFluxoAutoridadeSuperior() {
            return this.resumoCompraDireta.ehFluxoAutoridadeSuperior
        },
        itemLoteEstaEmHomologacao() {
            return this.ehFluxoAutoridadeSuperior && this.estaEmHomologacao
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        azAuth,
        predicate(coluna) {
            if(this.itemLoteEstaEmHomologacao) return true
            return coluna.value !== 'situacaoHomologacao'
        },
        pegarTamanho() {
            this.tamanho = .04 * window.innerWidth
        },
        estilizarLinhaCondicionalmente(statusFornecedor) {
            switch (statusFornecedor) {
            case 'EMPATADO':
                return 'linha-info linha-empatado'
            case 'DESCLASSIFICADO':
                return 'linha-info linha-desclassificado'
            case 'INABILITADO':
                return 'linha-info linha-desclassificado'
            case 'ADJUDICADO':
                return 'linha-info linha-adjudicado'
            default:
                return 'linha-info'
            }
        },
        analisarDoc(pessoaId, itemId, loteId) {
            this.$emit('analisarDocumentacao', {pessoaId, itemId, loteId})
        },
        propagarEventoDesclassificar(rankingId, motivo){
            let comboPainelRankingTabela = {
                rankingId: rankingId,
                motivo: motivo
            }
            this.$emit('desclassificar', comboPainelRankingTabela)
        },
        propagarEventoInabilitar(pessoaId, rankingId, dadosModalInabilitar){
            const comboPainelRankingTabela = {
                rankingId: rankingId,
                pessoaId: pessoaId,
                motivo: dadosModalInabilitar.motivo,
                inabilitarTodos: dadosModalInabilitar.inabilitarTodos
            }

            this.$emit('inabilitar', comboPainelRankingTabela)
        },
        propagarEventoReclassificar(rankingId, motivo) {
            const comboPainelRankingTabela = {
                rankingId: rankingId,
                motivo: motivo
            }
            this.$emit('reclassificar', comboPainelRankingTabela)
        },
        propagarEventoHabilitar(pessoaId, rankingId, dados) {
            const comboPainelRankingTabela = {
                rankingId: rankingId,
                pessoaId: pessoaId,
                motivo: dados.motivo,
                habilitarTodos: dados.habilitarTodos
            }

            this.$emit('habilitar', comboPainelRankingTabela)
        },
        propagarEventoNegociar(rankingId, comboNegociar) {
            let comboPainelRankingTabela = {
                rankingId: rankingId,
                mensagem: comboNegociar.mensagem
            }
            this.$emit('negociar', comboPainelRankingTabela)
        },
        propagarEventoCancelarAdjudicacao(rankingId, pessoaId, motivo) {
            const comboPainelRankingTabela = {
                rankingId: rankingId,
                motivo: motivo,
                pessoaId: pessoaId
            }
            this.$emit('cancelarAdjudicacao', comboPainelRankingTabela)
        },
        propagarEventoCancelarDeclaracaoVencedor(rankingId, pessoaId, motivo) {
            const comboPainelRankingTabela = {
                rankingId: rankingId,
                motivo: motivo,
                pessoaId: pessoaId
            }
            this.$emit('cancelarDeclaracaoVencedor', comboPainelRankingTabela)
        },
        mostrarBotaoAdjudicar(fornecedor){
            if (this.resumoCompraDireta.ehFluxoAutoridadeSuperior){
                return false
            }

            return this.podeMostrarBotaoAdjudicarOuEnviarParaAdjudicacao(fornecedor)
        },
        mostrarBotaoRemoverProposta() {
            return this.ehCompraPropostaManualEhAtiva()
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva() && this.amparoLegalEhLei14133Art75VIII()
        },
        mostarBotaoMensagens() {
            return !(this.propostaManualAtiva() && this.amparoLegalEhLei14133Art75VIII())
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.resumoCompraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
        removerProposta(item) {
            const comboRemoverProposta = {
                fornecedorId: item.pessoaId
            }
            this.$emit('removerProposta', comboRemoverProposta)
        },
        mostrarBotaoEnviarParaHomologacao(fornecedor) {
            if (this.resumoCompraDireta.ehFluxoAutoridadeSuperior && fornecedor.processamento !== 'AGUARDANDO_HOMOLOGACAO') {
                return this.podeMostrarBotaoAdjudicarOuEnviarParaAdjudicacao(fornecedor)
            }
        },
        podeMostrarBotaoAdjudicarOuEnviarParaAdjudicacao(fornecedor) {
            if(fornecedor.negociacao && fornecedor.negociacao.aceito) {
                return fornecedor.status === 'EM_ANALISE'
                    && fornecedor.documentacao === 'ANALISADA'
                    && fornecedor.lanceVencedorReajustado <= fornecedor.negociacao.valor
            } else {
                return fornecedor.status === 'EM_ANALISE'
                    && fornecedor.documentacao === 'ANALISADA'
            }
        },
        mostrarBotaoMaisOpcoes(fornecedor) {

            if (this.situacaoItemOuLote === 'ADJUDICADO' && (fornecedor.status === 'DESCLASSIFICADO' || fornecedor.status === 'INABILITADO')) return false

            return fornecedor.status === 'EM_ANALISE' || fornecedor.status === 'DESCLASSIFICADO' || fornecedor.status === 'ADJUDICADO' || fornecedor.status === 'INABILITADO'
        },
        mostrarOpcaoReclassificar(fornecedor) {
            return fornecedor.status === 'DESCLASSIFICADO'
        },
        mostrarOpcoesHabilitar(fornecedor){
            return fornecedor.status === 'INABILITADO' || fornecedor.status === 'EM_ANALISE'
        },
        mostrarOpcoesNegociarEDesclassificar(fornecedor) {
            return fornecedor.status === 'EM_ANALISE'
        },
        mostrarOpcaoCancelarAdjudicacao(item){
            return (item.status === 'ADJUDICADO' &&
                this.azAuth(this.loki.user.authorities, ['Comprador.Autoridade.Superior'])
            && this.ehFluxoAutoridadeSuperior)
        },
        deveExibirAcoes(situacaoItemOuLote, itemRanking) {
            return situacaoItemOuLote === 'EM_ANDAMENTO' || ['ADJUDICADO', 'DESCLASSIFICADO', 'INABILITADO'].includes(itemRanking.status)
        },
        ehCompraSuspensa() {
            return this.situacaoCompraDireta === 'SUSPENSA'
        },
        baixarTodosDocumentos(pessoaId, razaoSocial){
            const data = {
                compraDiretaId: this.compraDiretaId,
                pessoaId: pessoaId,
                razaoSocial: razaoSocial ? razaoSocial : 'apresentados'
            }
            this.$emit('baixarTodosDocumentos', data)
        },
        solicitarReadequacao(dados){
            this.$emit('solicitarReadequacao', {compraDiretaId: this.compraDiretaId, ...dados})
        },
        propagarEventoCancelarNegociacao(itemOuLote, motivo) {
            const cancelarNegociacaoDados = {
                itemOuLote,
                motivo
            }
            this.$emit('cancelarNegociacao', cancelarNegociacaoDados)
        },
        eventoAbrirModalSolicitarReadequacao(ranking){
            this.$emit('eventoAbrirModalSolicitarReadequacao', ranking)
        },
        mostrarCancelarEnvioHomologacao(ranking) {
            return this.ehFluxoAutoridadeSuperior && ranking.processamento === 'AGUARDANDO_HOMOLOGACAO'
        },
        propagarEventoCancelarEnvioHomologacao(itemOuLote) {
            this.$emit('cancelarEnvioHomologacao', itemOuLote)
        },
        ehProcessamentoLegal(ranking){
            return ranking.processamento && ranking.processamento !== 'ANALISANDO'
        },
        permitirVisualizarDocumentoDesempate(ranking){
            return ranking.status === 'EMPATADO' && ranking.posicao === 1 && this.lanceFechadoFinalizado
        },
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
    //TODO Aqui também
}
</script>

<style lang="stylus">
    .botaoMaisAcoes
        margin 0

    .actions
      display flex
      align-items center
      gap 8px

    .circulo
        background-color #d6d6d6
        color #282828
        border-radius 100%
        padding 3px 0 0 3px
        width 25px
        height 25px
        text-align center

    .linha-info
        border-bottom 0 !important
        border-top 1px solid rgba(0, 0, 0, .12)

    .tabela-ranking
        padding 16px

        tr
            border 0

        tr:last-child
            border-bottom 0 !important

        thead tr th
            padding 5px 10px !important
            font-weight bold

        .v-datatable__expand-col
            border-bottom 1px solid #ddd
            padding-top 0 !important

    .tabela-ranking.ranking-normal
        .v-table tbody tr:hover:not(.v-datatable__expand-row)
            background-color #f3f3f3 !important

    .tabela-ranking .linha-info.linha-empatado
        &, &:nth-child(even)
            background-color #fff4e0 !important

        td
            color #3c3c3c

        .circulo
            background-color var(--v-primary-lighten1) !important
            font-weight bold

            span
                color white

    .tabela-ranking .linha-info.linha-desclassificado
        td:nth-child(-n+3)
            text-decoration line-through

    .tabela-ranking .linha-info.linha-adjudicado
        background-color #efefef !important

        td
            color #3c3c3c !important

        .circulo
            background-color var(--v-primary-darken2) !important
            color white
            font-weight bold

    @media (max-width 720px)
        .tabela-ranking
            padding 0

            td:nth-of-type(1):before
                content "Posição:"

            td:nth-of-type(2):before
                content "Fornecedor:"

            td:nth-of-type(3):before
                content "Lance Venc.:"

            td:nth-of-type(4):before
                content "Status:"

            td:nth-of-type(5):before
                content "Documentação:"

            td:nth-of-type(6):before
                content "Ações:"

            td:nth-of-type(1)
                text-align left

            td:nth-of-type(2)
                text-align left

            td:nth-of-type(3)
                text-align left

            td:nth-of-type(4)
                text-align left

            td:nth-of-type(5)
                text-align left
</style>
